module.exports = __webpack_public_path__ + "static/media/video-6.fa464795.jpg";